import studentApi from "./studentApi";
import { STUDENT_ENDPOINTS } from "./studentEndpoints";

// Confirmed against the real backend (2026-10-22): both OTP endpoints reject
// a flat body with {"error":"Invalid request format"} and require it wrapped
// in a "data" envelope, e.g. {"data": {"id_number": "...", "otp": "..."}}.
export const sendLoginOtp = async (payload) => {
  const response = await studentApi.post(STUDENT_ENDPOINTS.AUTH.SEND_LOGIN_OTP, { data: payload });
  return response;
};

export const verifyLoginOtp = async (payload) => {
  const response = await studentApi.post(STUDENT_ENDPOINTS.AUTH.VERIFY_LOGIN_OTP, { data: payload });
  return response;
};

export const logoutStudent = async () => {
  const response = await studentApi.post(STUDENT_ENDPOINTS.AUTH.LOGOUT);
  return response;
};

export const storeStudentFcmToken = async (fcmToken) => {
  const response = await studentApi.post(STUDENT_ENDPOINTS.AUTH.STORE_FCM_TOKEN, { token: fcmToken });
  return response;
};
